export default "/assets/eb0df47b3f3addeff9b4c7f7f0be90cb.png";